module.exports = __webpack_public_path__ + "static/media/panel.d0ae3967.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/maps/panel.svg
// module id = 958
// module chunks = 0